import { type Ref, ref, onScopeDispose } from 'vue';

export function createFullscreen(dependencies: { fullscreenTarget: Ref<HTMLElement | null> }) {
  const isFullScreen = ref(false);
  const isFullScreenSupported = ref(!!document.fullscreenEnabled);

  function onFullscreenChange() {
    const fullscreenTargetElement = dependencies.fullscreenTarget.value;
    isFullScreen.value = fullscreenTargetElement instanceof HTMLElement && document.fullscreenElement === fullscreenTargetElement;
  }

  document.addEventListener('fullscreenchange', onFullscreenChange);

  onScopeDispose(() => {
    document.removeEventListener('fullscreenchange', onFullscreenChange);
  });

  function toggleFullScreen() {
    const fullscreenTargetElement = dependencies.fullscreenTarget.value;

    if (!fullscreenTargetElement)
      return;

    if (isFullScreen.value) {
      document.exitFullscreen().catch(() => {});
      return;
    }

    fullscreenTargetElement.requestFullscreen().catch(() => {
      isFullScreenSupported.value = false;
    });
  }

  return { isFullScreen, isFullScreenSupported, toggleFullScreen };
}
